import script from "./CustomHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomHeader.vue?vue&type=script&setup=true&lang=ts"

import "./CustomHeader.vue?vue&type=style&index=0&id=1f38c982&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f38c982"]])

export default __exports__